import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
    notificationFeatureKey,
    NotificationState,
} from './notification.reducer';

export const selectNotificationFeature =
    createFeatureSelector<NotificationState>(notificationFeatureKey);

export const selectNotifications = createSelector(
    selectNotificationFeature,
    (state) => state.notifications,
);

export const selectUnreadNotificationsCount = createSelector(
    selectNotificationFeature,
    (state) => state.unreadNotificationsCount,
);

export const selectOnlyUnread = createSelector(
    selectNotificationFeature,
    (state) => state.onlyUnread,
);
